<template>
  <div class="container">
    <img
      :class="{ flipped: orientation === -1, marked: marked === true, shaking: shaking === true }"
      :src="require('@/assets/baseballcap_left.png')"
    />
  </div>
</template>

<script>
export default {
  name: "Cap",
  props: {
    orientation: {
      type: Number,
      required: true
    },
    marked: {
      type: Boolean,
      required: true,
      default: false
    },
    shaking: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: function() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

img.shaking {
  border-radius: 1em;
  box-shadow: 0px 0px 12px 3px #343a40;
  border-radius: 1em;
  background: content-box radial-gradient(rgb(139, 143, 148), #343a40);
  animation: shake-flipped 1.2s;
  animation-iteration-count: infinite;
}

img.shaking.flipped {
  animation: shake 1.2s;
  animation-iteration-count: infinite;
}

@keyframes shake-flipped {
  0% { transform: scaleX(-1) translate(1px, 1px) rotate(0deg); }
  10% { transform: scaleX(-1) translate(-1px, -2px) rotate(-1deg); }
  20% { transform: scaleX(-1) translate(-3px, 0px) rotate(1deg); }
  30% { transform: scaleX(-1) translate(3px, 2px) rotate(0deg); }
  40% { transform: scaleX(-1) translate(1px, -1px) rotate(1deg); }
  50% { transform: scaleX(-1) translate(-1px, 2px) rotate(-1deg); }
  60% { transform: scaleX(-1) translate(-3px, 1px) rotate(0deg); }
  70% { transform: scaleX(-1) translate(3px, 1px) rotate(-1deg); }
  80% { transform: scaleX(-1) translate(-1px, -1px) rotate(1deg); }
  90% { transform: scaleX(-1) translate(1px, 2px) rotate(0deg); }
  100% { transform: scaleX(-1) translate(1px, -2px) rotate(-1deg); }
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

/* TODO use shared place */
img.flipped {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
img.marked {
  -moz-box-shadow: 0 0 12px 3px #343a40;
  -webkit-box-shadow: 0 0 12px 3px #343a40;
  box-shadow: 0px 0px 12px 3px #343a40;
  border-radius: 1em;
  background: content-box radial-gradient(rgb(139, 143, 148), #343a40);
}

.container {
  width: 100px;
  height: 65px;
  display: inline-grid;
}
.container img {
  width: 100%;
  height: auto;
}
</style>
